/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { createEncumbrancesBulk } from 'modules/partners/api/createEncumbrancesBulk';
import { chunkArray } from 'modules/_shared/components/Modals/UploadPartner/utils/chunkArray';

import { EncumbrancesBulkItemPayload } from './encumbrancesExcelImportHelpers';

export const ENCUMBRANCES_BULK_BATCH_SIZE = 50;

export type EncumbrancesImportProgress = {
  total: number;
  processed: number;
  created: number;
  failed: number;
};

export type ImportEncumbrancesInBatchesResult = {
  created: number;
  failed: number;
  firstError?: string;
};

const getFirstBulkError = (
  results: { success: boolean; error?: string }[] = []
): string | undefined =>
  results.find((item) => !item.success && item.error)?.error;

export const importEncumbrancesInBatches = async ({
  societyId,
  encumbrances,
  batchSize = ENCUMBRANCES_BULK_BATCH_SIZE,
  onProgress,
}: {
  societyId: string;
  encumbrances: EncumbrancesBulkItemPayload[];
  batchSize?: number;
  onProgress?: (progress: EncumbrancesImportProgress) => void;
}): Promise<ImportEncumbrancesInBatchesResult> => {
  const total = encumbrances.length;
  const chunks = chunkArray(encumbrances, batchSize);

  let processed = 0;
  let created = 0;
  let failed = 0;
  let firstError: string | undefined;

  const reportProgress = () => {
    onProgress?.({ total, processed, created, failed });
  };

  reportProgress();

  for (const chunk of chunks) {
    try {
      const result = await createEncumbrancesBulk({
        societyId,
        encumbrances: chunk,
      });

      created += result.created;
      failed += result.failed;

      if (!firstError) {
        firstError = getFirstBulkError(result.results);
      }
    } catch {
      failed += chunk.length;
    }

    processed += chunk.length;
    reportProgress();
  }

  return { created, failed, firstError };
};
